import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import {Provider} from "react-redux";
// import store from "./Redux/store.js";
// // import App1 from './App1.js';
// import {App2} from "./App2.js";


ReactDOM.render(
  
  
    <App />,
  

  document.querySelector("#root")
);

